import { useEffect, useState } from 'react'
import { tankRectPx } from '../Ballpit/tank'

/**
 * Where the tank is narrower than the screen (an ultra-wide display), the world beyond its
 * walls is darker, so rings turning back at the walls do not look as if they bounced off
 * nothing. On a normal screen the tank is the screen and this draws nothing: the glass is the
 * screen itself, seen from the front, and the water is told by what moves in it.
 */
export const TankGlass: React.FC = () => {
  const [rect, setRect] = useState(() => tankRectPx(window.innerWidth, window.innerHeight))
  useEffect(() => {
    const onResize = () => setRect(tankRectPx(window.innerWidth, window.innerHeight))
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])
  const { left, right } = rect
  if (left <= 0.5 && right >= window.innerWidth - 0.5) return null
  const outside: React.CSSProperties = { position: 'absolute', top: 0, bottom: 0, background: 'rgba(0,0,0,0.55)' }
  return (
    <div aria-hidden="true" data-testid="tank-glass" className="pointer-events-none absolute inset-0 z-[2]">
      {left > 0.5 && <div style={{ ...outside, left: 0, width: left }} />}
      {right < window.innerWidth - 0.5 && <div style={{ ...outside, left: right, right: 0 }} />}
    </div>
  )
}
